import reducer from './reducers/index';
import routes from '../routes'
import * as availableJobsActions from './actions';
import * as availableJobsOperations from './operations';
import * as availableJobsSelectors from './selectors';

export {
    availableJobsOperations,
    availableJobsSelectors,
    availableJobsActions,
};

export default {
    reducer,
    routes
};
